import { createApp, reactive } from 'vue'
import App from './App.vue'
import { translationPlugin } from '@/plugins';

const app = createApp(App);
app.config.globalProperties.$localization = reactive({
    translations: {},
    lang: document.getElementById('lang')?.innerText || 'en',
});
app.config.globalProperties.$mediaPath = process.env.NODE_ENV === 'development'
    ? ''
    : '/wp-content/uploads/tariffVue';

app.use(translationPlugin);
app.mount('#tariff-page');